import strings from "../../localization";
import React from "react";
import SelectControl from "../../components/controls/SelectControl";
import IconButton from "@material-ui/core/IconButton";

const RenewalProcessingReportHeader = ({
  reports,
  selectedReport,
  onChange,
  load,
  preload
}) => {
  const formatDateRange = (report) => {
    if (!report.fromDate || !report.toDate) return report.dateCreated;
    
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };
    
    return `${formatDate(report.fromDate)} - ${formatDate(report.toDate)} (${report.dateCreated})`;
  };

  const reportsWithFormattedDates = reports ? reports.map(report => ({
    ...report,
    displayName: formatDateRange(report)
  })) : [];

  return (
    <form style={{ display: 'flex', flexDirection: 'row', alignContent: 'flex-start', alignItems: 'flex-start' }}>
      <div style={{ width: 200, marginTop: 50 }}>
        <SelectControl
          options={reportsWithFormattedDates}
          selected={selectedReport}
          onChange={onChange}
          label={strings.renewalList.processingReports}
          name={"selectedReport"}
          nameKey={"displayName"}
          valueKey={"id"}
        />
      </div>

      <div className="select-grave-site-button" style={{ marginLeft: 25, marginTop: 70 }}>
        <IconButton
          onClick={load}
          disabled={
            selectedReport == undefined || selectedReport.id == -1
          }
        >
          {strings.review.buttons.loadProcessingReport}
        </IconButton>
      </div>

      <div className="select-grave-site-button" style={{ marginLeft: 25, marginTop: 70 }}>
        <IconButton
          onClick={preload}
          disabled={
            selectedReport == undefined || selectedReport.id == -1
          }
        >
          {strings.review.buttons.loadPreReport}
        </IconButton>
      </div>
    </form>
  );
};

export default RenewalProcessingReportHeader;
